import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { featureToggleGuard } from 'ish-core/feature-toggle.module';

const routes: Routes = [
  {
    path: 'punchout/demo-return',
    canActivate: [featureToggleGuard],
    data: {
      feature: 'punchout',
      meta: { title: 'punchout.demo.return.title' },
    },
    loadComponent: () =>
      import('./punchout-demo-return/presidio-punchout-demo-return-page.component').then(
        m => m.PresidioPunchoutDemoReturnPageComponent
      ),
  },
  {
    path: 'punchout',
    canActivate: [featureToggleGuard],
    data: { feature: 'punchout' },
    loadChildren: () => import('./punchout/punchout-page.module').then(m => m.PunchoutPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class PunchoutRoutingModule {}
